import AdminDashboardHome from "../../components/admin/AdminDashboardHome";

const AdminPage = () => {
  return (
    <main className="mx-auto max-w-5xl px-6 py-12">
      <AdminDashboardHome />
    </main>
  );
};

export default AdminPage;
